import { StarFill } from '@cat-home-experts/mortar-iconography-web/StarFill';
import { colors } from '@checkatrade/web-ui/themes';
import { Chip } from '@checkatrade/web-ui';

export const MostRecentlyReviewed = () => (
  <Chip
    color="neutral"
    leadingElement={
      <div className={'-ml-0.5'}>
        <StarFill size={16} color={colors.secondary.DEFAULT} />
      </div>
    }
  >
    Most recently reviewed
  </Chip>
);
